import i18n from "locales/i18n";
import { useEffect, useRef, useState } from "react";
import { countryCode } from "./countryCode";
import { useAuthContext } from "components/context/authContext";
import "../select.scss";

type ISelect = {
  name?: string;
  styles?: string;
  option?: string;
  defaultValue?: any;
  onChange?(item: ICountry): void;
};

type ICountry = {
  ko: string;
  en: string;
  code: string;
  phone: string;
};

export default function CountryCode({
  name = "mobCntyCd",
  styles = "",
  option = undefined,
  onChange,
}: ISelect) {
  const { viewPort } = useAuthContext();
  const slectRef = useRef<HTMLDivElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const ulRef = useRef<HTMLUListElement>(null);
  const langCd = i18n.language;
  const list = countryCode as ICountry[];

  const firstValue = countryCode[0];
  const [selected, setSelected] = useState<ICountry>({
    ko: firstValue.ko,
    en: firstValue.en,
    code: firstValue.code,
    phone: firstValue.phone,
  });

  useEffect(() => {
    if (option) {
      const value = list.find((li) => {
        return "+" + li.phone === option;
      });

      if (value) {
        setSelected(value);
      }
    }
  }, [option]);

  return (
    <div className={"select" + " " + "country" + " " + styles} ref={slectRef}>
      <input
        type="text"
        ref={inputRef}
        data-phone={selected?.phone || firstValue.phone}
        name={name}
        value={
          "+" +
          selected?.phone +
          (viewPort?.screen === "web"
            ? "(" + selected[langCd as keyof ICountry] + ")"
            : "")
        }
        readOnly
        onClick={(e) => {
          if (ulRef.current && slectRef.current) {
            const classList = Array.from(slectRef.current.classList);

            if (!classList.includes("rotate")) {
              slectRef.current.classList.add("rotate");
              ulRef.current.classList.remove("hidden");
            }
            if (classList.includes("rotate")) {
              slectRef.current.classList.remove("rotate");
              ulRef.current.classList.add("hidden");
            }
          }
        }}
      />
      <ul ref={ulRef} className="hidden">
        {list.map((item, index) => {
          return (
            <li
              key={index}
              data-selected={selected?.phone === item.phone}
              onClick={(e) => {
                if (inputRef.current && ulRef.current) {
                  inputRef.current.value =
                    "+" +
                    item.phone +
                    "(" +
                    item[langCd as keyof ICountry] +
                    ")";

                  setSelected(item);
                  onChange && onChange(item);
                  if (slectRef.current) {
                    slectRef.current.classList.remove("rotate");
                    ulRef.current.classList.add("hidden");
                  }
                }
                if (inputRef.current) {
                  const { type } = inputRef.current.dataset;

                  type === "C" &&
                    inputRef.current.setAttribute("data-type", "U");
                }
              }}
            >
              {item[langCd as keyof ICountry]}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
